import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import ComicInformation from '@/components/disposable/ComicInformation.vue';
import { Comic, ComicStatus, ComicType } from '@/model/comic';
import { createComic } from '@/repository/comic';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateMangaView',
  setup(__props) {

const store = useStore();
const { push } = useRouter();

const isLoading = ref(false);

const comic = ref<Comic>({
	imageURL: '',
	title: '',
	author: '',
	chapter: {},
	description: '',
	genres: [],
	note: '',
	status: ComicStatus.Ongoing,
	type: ComicType.Manga
});

async function submit(comic: Comic) {
	try {
		isLoading.value = true;
		const res = await createComic(comic);
		if (res.data) {
			isLoading.value = false;
			store.dispatch('alert', {
				type: 'success',
				message: `Create new ${comic.type} successfully!`
			});
			await push(`/${comic.type}/${res.data.comicUUID}`);
			return;
		}
		throw Error('Something went wrong, please try again!');
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComicInformation, {
    comicStatuses: [_unref(ComicStatus).Ongoing, _unref(ComicStatus).Complete, _unref(ComicStatus).Oneshot],
    isLoading: isLoading.value,
    comic: comic.value,
    onSubmit: submit
  }, null, 8, ["comicStatuses", "isLoading", "comic"]))
}
}

})